module.exports = __webpack_public_path__ + "static/media/mnf-stack.11c4930f.png";